const SYNTHETIC_CHAT_JOURNEY_ID_PATTERN = /^(departing|returning|flight(?:-\d+)?|flight-recommendation)-/

export function isResolvedFlightJourneyId(journeyId: string | undefined, journeyKey?: string): boolean {
  if (!journeyId) return false
  if (journeyKey && journeyId === journeyKey) return false
  return !SYNTHETIC_CHAT_JOURNEY_ID_PATTERN.test(journeyId)
}
